import { CarFilter, MileageFilter } from '@/types/filters/filters.types';
import { atom, DefaultValue, selector } from 'recoil';

const defaultMileageConstraints = { min: 0, max: 0 };

export const searchMileageTypesState = atom<CarFilter[]>({
  key: 'searchMileageTypes',
  default: [],
});

export const searchMileageTypeSearchOptionsSelector = selector({
  key: 'searchMileageTypeSearchOptionsSelector',
  get: ({ get }) => {
    const searchMileageTypes = get(searchMileageTypesState);
    const searchMileageTypeSearchOptions: CarFilter[] =
      searchMileageTypes.filter((option) => !option.isSelected);

    return { searchMileageTypeSearchOptions };
  },
});

export const mileageFilterDefaultState = atom<MileageFilter>({
  key: 'mileageFilterDefaultState',
  default: defaultMileageConstraints,
});

export const mileageFilterState = atom<MileageFilter>({
  key: 'mileageFilter',
  default: defaultMileageConstraints,
});

const selectedMileageFilterState = atom<MileageFilter>({
  key: 'mileageSelectedFilterState',
  default: defaultMileageConstraints,
});

export const selectedMileageFilterSelector = selector<MileageFilter>({
  key: 'mileageSelectedFilterSelector',
  get({ get }) {
    return get(selectedMileageFilterState);
  },
  set({ get, set }, mileage) {
    if (mileage instanceof DefaultValue) {
      return;
    }

    const mileageFilterDefault = get(mileageFilterDefaultState);

    if (
      mileageFilterDefault.min === mileage.min &&
      mileageFilterDefault.max === mileage.max
    ) {
      return set(selectedMileageFilterState, { min: 0, max: 0 });
    }

    return set(selectedMileageFilterState, mileage);
  },
});

export const hasSelectedMileageFilterSelector = selector<boolean>({
  key: 'hasSelectedMileageFilterSelector',
  get({ get }) {
    const { min, max } = get(selectedMileageFilterState);
    const { min: defaultMin, max: defaultMax } = get(mileageFilterDefaultState);

    return min > defaultMin || (Boolean(max) && max < defaultMax);
  },
});

export const selectedMileageFilterLabelSelector = selector<string>({
  key: 'selectedMileageFilterStateSelector',
  get: ({ get }) => {
    const hasSelectedMileageFilter = get(hasSelectedMileageFilterSelector);
    const { min, max } = get(selectedMileageFilterSelector);

    if (hasSelectedMileageFilter) {
      return `${min} - ${max}`;
    }

    return '';
  },
});
